import { deleteData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGN } from './mediaPlanning';

export interface SavePlanResponseData {
  id: string;
}
export const deletePlan = async (id: string) => {
  return deleteData<ApiResponse<{ id: string }>>(
    `/${CAMPAIGN}/media-plans/${id}`
  );
};
